export default __webpack_public_path__ + "15f201f629c55d8770596eef33c7c7b1.png";